import { useEffect } from 'react'
import { campaignFlowService } from '@forwardflow/features/campaign-flow/services'
import { useFlowData } from '@forwardflow/features/campaign-flow/store/flow-data.store'

/** Loads the organization, sample lead, number price and voices once per page. */
export const useFlowReferenceData = () => {
   useEffect(() => {
      const { setContext, setVoices } = useFlowData.getState()
      void campaignFlowService
         .context()
         .then(setContext)
         .catch(() => undefined)
      void campaignFlowService
         .voices()
         .then(setVoices)
         .catch(() => undefined)
   }, [])
}
